export default __webpack_public_path__ + "static/media/Balloon_02.9ba106bd.png";